import { useCallback, useState } from "react";
import { useInfiniteQuery, useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useCompletedProjectsFilters = (config) => {
  return useQuery({
    ...config,
    queryKey: ["completed-projects-filters"],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/archive-filters`,
        signal,
      }),
  });
};

export const useCompletedProjects = (queryParams, config) => {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 30,
    total: 0,
  });

  const fetchData = useCallback(
    ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        ...queryParams,
      };
      return fetch({
        url: `${Angie.api_url}/projects/archive?${encodeData(params)}`,
        withHeaders: true,
      }).then((response) => {
        const _pagination = {
          page: parseInt(response._headers["x-angie-paginationcurrentpage"], 10),
          perPage: parseInt(response._headers["x-angie-paginationitemsperpage"], 10),
          total: parseInt(response._headers["x-angie-paginationtotalitems"], 10),
        };
        setPagination(_pagination);
        return response._parsedBody;
      });
    },
    [queryParams]
  );

  return useInfiniteQuery({
    ...config,
    queryKey: ["completed-projects", queryParams],
    queryFn: fetchData,
    getNextPageParam: () => {
      const totalPages = Math.ceil(pagination.total / pagination.perPage);
      if (pagination.page < totalPages) {
        return pagination.page + 1;
      }
      return undefined;
    },
  });
};
